export enum SizeModeEnum {
  Normal = 0,
  Narrow = 1
}
